export { IReadStatus } from './IReadStatus';

